import { CheckoutState } from '../reducers';
import { createSelector } from 'reselect';
import { getOrder } from '../order/selectors';
import { NASProductCategory, SelectedNASProduct, NASProductType, NASProductFragment } from '@websky/graphql';

export const getEveryPortSelectedServices = (state: CheckoutState) => state.everyPort.selectedServices;

export const getEveryPortLoungeService = createSelector(getOrder, order => {
	return order.additionalServices.nas?.services?.filter(service => service.type === NASProductType.Lounge) ?? [];
});

export const getEveryPortServicesByCategories = createSelector(getEveryPortLoungeService, services => {
	const servicesMap = new Map<NASProductCategory, NASProductFragment[]>();

	services.forEach(service => {
		servicesMap.set(service.category, [...(servicesMap.get(service.category) || []), service]);
	});

	return servicesMap;
});

export const getEveryPortSelectedServicesArray = createSelector(getEveryPortSelectedServices, selectedServices => {
	const services: SelectedNASProduct[] = [];

	Object.values(selectedServices).forEach(servicesByCategory => {
		servicesByCategory.forEach(service => {
			services.push({
				id: service.product.id,
				additionalServices: service.additionalServices,
				travellerIds: service.travellerIds
			});
		});
	});

	return services;
});
